module.exports = __webpack_public_path__ + "img/logo8.ff8caa66.png";